export default "__VITE_ASSET__BB1daA8F__"